import { useProfileStore } from '@/store/useProfileStore.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';

export const handleOneTimePurchase = (ctxData: WebSocketMessage) => {
  const { updateRemainingAmount } = useProfileStore.getState();

  if (
    ctxData.one_time_purchase_event?.transaction.product.name === 'gift.generic'
  ) {
    updateRemainingAmount(
      ctxData.one_time_purchase_event?.transaction.quantity ?? 0
    );
  }
};
